import {Component, Input, OnInit} from '@angular/core';
import {TranslateModule} from "@ngx-translate/core";
import {MatIcon} from '@angular/material/icon';
import {MatAnchor} from '@angular/material/button';
import {DatePipe, NgIf, NgOptimizedImage} from '@angular/common';
import {MatCard, MatCardContent} from '@angular/material/card';
import {HeadlineWithIconComponent} from "../headline-with-icon/headline-with-icon.component";

@Component({
    selector: 'headline-with-icon-and-info-box',
    templateUrl: './headline-with-icon-and-info-box.component.html',
    styleUrls: ['./headline-with-icon-and-info-box.component.scss'],
    standalone: true,
  imports: [MatCard, NgIf, MatAnchor, MatIcon, DatePipe, TranslateModule, NgOptimizedImage, HeadlineWithIconComponent, MatCardContent]
})
export class HeadlineWithIconAndInfoBoxComponent implements OnInit{

  @Input() headline!: string;
  @Input() icon!: string;
  @Input() infoBoxHeadline!: string;
  @Input() infoBoxText!: string;

  ngOnInit(): void {
    if(!this.icon) this.icon = "success";
  }
}
